<script>
export default {
  name: 'formRender',
  functional: true,
  props: {
    value: {
      type: Object,
      default: '',
    },
    render: {
      type: Function,
      default: () => {
        return null
      },
    },
  },
  render(h, ctx) {
    const props = ctx.props || {}
    const attrs = ctx.data.attrs || {}
    let props_obj = {}
    // 合并prop和属性
    props_obj = Object.assign(props, attrs)
    // console.log('formRender props attrs props_obj', props, attrs, props_obj)
    if (ctx.props && ctx.props.render) {
      return ctx.props.render(h, ctx, props_obj, props_obj.value)
    }
    return null
  },
}
</script>
